import { forwardRef } from "react";

import { cx, styled } from "simplydo/react/styled";

import { ContentEl } from "./Modal.styles";
import type { ModalContentProps } from "./Modal.types";

const ModalContentComponent = forwardRef<HTMLDivElement, ModalContentProps>(
  (props, ref) => {
    const { children, content, scrolling, className, style } = props;
    return (
      <ContentEl
        ref={ref}
        className={cx(scrolling && "is-scrolling", className)}
        style={style}
      >
        {children ?? content}
      </ContentEl>
    );
  },
);

ModalContentComponent.displayName = "ModalContent";

export const ModalContent = styled(ModalContentComponent)``;
